import { App as AntdApp, ConfigProvider } from 'antd'
import arEG from 'antd/locale/ar_EG'
import enUS from 'antd/locale/en_US'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'

import { router } from './app/router'
import { useAppSelector } from './app/store'
import i18n from './i18n'
import { buildTheme } from './theme'
import 'dayjs/locale/ar'
import 'dayjs/locale/en'

export default function App() {
  const { language, themeMode, themeStyle } = useAppSelector((s) => s.ui)

  useEffect(() => {
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr'
    document.documentElement.lang = language
    dayjs.locale(language)
    i18n.changeLanguage(language)
  }, [language])

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', themeMode)
  }, [themeMode])

  useEffect(() => {
    document.documentElement.setAttribute('data-style', themeStyle)
  }, [themeStyle])

  return (
    <ConfigProvider
      direction={language === 'ar' ? 'rtl' : 'ltr'}
      locale={language === 'ar' ? arEG : enUS}
      theme={buildTheme(themeMode, language, themeStyle)}
    >
      {/* مزوّد antd App: يفعّل message/notification/modal لكل صفحة تستخدم App.useApp() */}
      <AntdApp>
        {/* افتتاحية الفيديو تعمل من index.html نفسه — قبل تحميل النظام، مرة بكل جلسة */}
        <RouterProvider router={router} />
      </AntdApp>
    </ConfigProvider>
  )
}
